/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { StlRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { StlListItem } from './stl.model';

@Injectable()
export class StlBusinessService implements InitViewService {
  constructor(private stlRest: StlRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('scheduledTasks'),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<StlListItem> {
    return this.stlRest.findAllAsDataSource(filter);
  }
}
